import type { TFunction } from 'i18next';
import type { QuizNavigationGuidanceDto } from '../services/contentService';

export type QuizGuidanceScope = 'lesson' | 'level' | 'course';

/**
 * Resolve localized next-step guidance from quiz result metadata (replaces hardcoded API English messages).
 */
export function localizeQuizNavigationGuidance(
  t: TFunction,
  quizType: QuizGuidanceScope,
  passed: boolean,
  guidance?: QuizNavigationGuidanceDto | null
): string {
  if (!guidance) return '';

  const nextAction = (guidance.nextActionType ?? '').toLowerCase();

  if (quizType === 'course') {
    return passed ? t('quiz.guidance.course.passed') : t('quiz.guidance.course.failed');
  }

  if (!passed) {
    return t(`quiz.guidance.${quizType}.failed`);
  }

  if (nextAction === 'proceed') {
    return t(`quiz.guidance.${quizType}.passedHasNext`);
  }

  return t(`quiz.guidance.${quizType}.passedComplete`);
}
